<div #switcherContainer class="fund-switcher" [class.fund-switcher--open]="isDropdownOpen()">
  <!-- Fund View Indicator -->
  @if (fundViewLabel()) {
    <p class="fund-switcher__view-label" [class.fund-switcher__view-label--yellow]="variant() === 'yellow'">
      {{ fundViewLabel() }}
    </p>
  }
  <!-- Trigger Button -->
  <button
    class="fund-switcher__button"
    [class.fund-switcher__button--yellow]="variant() === 'yellow'"
    [disabled]="disabled()"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeyDown($event)"
    type="button"
    [attr.aria-expanded]="isDropdownOpen()"
    [attr.aria-haspopup]="true"
    aria-label="Fund switcher">
    <div class="fund-switcher__content">
      <span class="fund-switcher__text">
        <span class="fund-switcher__name" [class.fund-switcher__name--yellow]="variant() === 'yellow'">{{ displayText() }}</span>
        @if (displayAccountNumber()) {
          <span class="fund-switcher__account" [class.fund-switcher__account--yellow]="variant() === 'yellow'">{{ displayAccountNumber() }}</span>
        }
      </span>
      <app-caret-icon
        [isOpen]="isDropdownOpen()"
        [color]="variant() === 'yellow' ? 'var(--colors-text-fund-account-yellow)' : 'var(--colors-text-fund-account)'"
        [customClass]="'fund-switcher__icon' + (variant() === 'yellow' ? ' fund-switcher__icon--yellow' : '')">
      </app-caret-icon>
    </div>
  </button>

  <!-- Dropdown -->
  @if (isDropdownOpen()) {
    <div
      class="fund-switcher__dropdown"
      [class.fund-switcher__dropdown--above]="dropdownOpenAbove()"
      [ngStyle]="dropdownStyle()"
      tabindex="0"
      role="listbox"
      [attr.aria-label]="'Fund selector dropdown'">
      <div class="fund-switcher__dropdown-inner">
        @for (fund of funds(); track fund.id; let i = $index; let isLast = $last) {
          @if (shouldShowFund(fund)) {
            <button
              class="fund-switcher__dropdown-item"
              [class.fund-switcher__dropdown-item--selected]="fund.id === selectedFundId()"
              [class.fund-switcher__dropdown-item--sub]="fund.level && fund.level > 0"
              [class.fund-switcher__dropdown-item--has-expand]="(!fund.level || fund.level === 0) && hasProjects(fund)"
              (click)="onFundSelected(fund)"
              role="option"
              [attr.aria-selected]="fund.id === selectedFundId()">

              @if (fund.level && fund.level > 0) {
                <div class="fund-switcher__dropdown-item-indicator"></div>
              }

              <div class="fund-switcher__dropdown-item-content">
                <div class="fund-switcher__dropdown-item-name">{{ fund.name }}</div>
                @if (fund.currency || fund.accountNumber) {
                  <div class="fund-switcher__dropdown-item-details">
                    @if (fund.currency) {
                      <div class="fund-switcher__dropdown-item-balance">
                        <span class="fund-switcher__dropdown-item-balance-label">Balance :</span>
                        <span class="fund-switcher__dropdown-item-balance-value"> {{ formatBalance(fund.balance) }} {{ fund.currency }}</span>
                      </div>
                    }
                    @if (fund.accountNumber) {
                      <div class="fund-switcher__dropdown-item-fund-no">
                        <span class="fund-switcher__dropdown-item-fund-no-label">Fund No. </span>
                        <span class="fund-switcher__dropdown-item-fund-no-value">{{ fund.accountNumber }}</span>
                      </div>
                    }
                  </div>
                }
              </div>

              @if ((!fund.level || fund.level === 0) && hasProjects(fund)) {
                <app-caret-icon
                  [isOpen]="isExpanded(fund.id)"
                  [width]="16"
                  [height]="16"
                  [color]="'#757575'"
                  [closedRotation]="-90"
                  [openRotation]="0"
                  (click)="toggleExpansion($event, fund.id)"
                  class="fund-switcher__expand-icon">
                </app-caret-icon>
              }
            </button>

            @if (!isLast && funds()[i + 1] && shouldShowFund(funds()[i + 1]) && (!funds()[i + 1].level || funds()[i + 1].level === 0)) {
              <div class="fund-switcher__dropdown-divider"></div>
            }
          }
        }
      </div>
    </div>
  }
</div>
